import {ReactComponent as GreenLine} from '../../../../assets/logos/green-line.svg'
import './index.scss'
import {useAnimation, motion} from "framer-motion"
import { useInView } from "react-intersection-observer";
import { useEffect } from 'react';
import { container, child4 } from "../../../../variants"

const merits = [
    {id:"merit1", icon:<GreenLine />, title:"Cost Saving", cont:"HR admin costs by up to 30% annually with our automated, streamlined processes!"},
    {id:"merit2", icon:<GreenLine />, title:"Flexibility", cont:"Experience seamless growth with adaptable HR solutions that scale effortlessly!"},
    {id:"merit3", icon:<GreenLine />, title:"Security Assurance", cont:"Top-tier encryption and compliance to safeguard your data with absolute confidence!"}
]

const HrMerits = () => {

    const ctrls = useAnimation();

    const { ref, inView } = useInView({
        threshold: 0.2,
        triggerOnce: false,
    });

    useEffect(() => {
        if (inView) {
            ctrls.start("visible");
        }
        if (!inView) {
            ctrls.start("hidden");
        }
    }, [ctrls, inView])


  return (
    <motion.div ref={ref} variants={container} initial="hidden" animate={ctrls} id="Merits" className='pro-merits d-flex flex-row justify-content-center'>
        <motion.ul className='pro-center d-flex flex-row justify-content-between align-items-start'>
            {merits.map((each)=> {
                return <motion.li className='d-flex flex-column justify-content-center merits-cont' key={each.id}>
                    <motion.div className='d-flex flex-row'>
                        <motion.span className='green-line'>{each.icon}</motion.span>
                        <motion.h3 variants={child4} className='text-18 font-weight-600 merit-head'>{each.title}</motion.h3>
                    </motion.div>
                    <p className=' font-weight-400 p-size merit-para'>{each.cont}</p>
                </motion.li>
            })}
        </motion.ul>
    </motion.div>
  )
}
export default HrMerits